<template>
    <section class="hero is-small">
        <div class="hero-body">
            <p class="title">
                Pixel Art Institute of Chicago
            </p>
            <p class="subtitle">
                Seeing the collection through pixels
            </p>
        </div>
    </section>
</template>

<script>
export default {
  name: 'Hero'
}
</script>

<style>

</style>